import React, { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { getLanguageName } from '../../../../../../helpers/getLanguageName';
import { ParagraphProps } from '../../styledComponents';

export type LanguageProps = {
  value: string;
  prefix?: boolean;
  as: ComponentType<ParagraphProps>;
};
export function Language(props: LanguageProps) {
  const { value, prefix, as: Component } = props;

  const { t } = useTranslation();

  const langText = getLanguageName(value);
  const text = prefix
    ? t('site.modules.course-option-display.language.prefix', {
        0: langText,
      })
    : langText;

  return <Component text={text} />;
}
